export interface DefaultValues {
  company_details: {
    name: string;
    address: string;
    company_certificate: Blob | File | string | null;
    pan_vat_certificate: File | string | null;
    currency_preference: 'NPR' | 'USD';
  };
  store_details: {
    name: string;
    warehouse_address: string;
    contact_number: string;
    store_logo: File | string | null;
  };
  bank_details: {
    bank_name: string;
    account_holder_name: string;
    branch_code: string;
    account_number: string;
    bank_cheque_book_scan_photo: File | string | null;
  };
}

export const defaultValues: DefaultValues = {
  company_details: {
    name: '',
    address: '',
    company_certificate: null,
    pan_vat_certificate: null,
    currency_preference: 'USD',
  },
  store_details: {
    name: '',
    warehouse_address: '',
    contact_number: '',
    store_logo: null,
  },
  bank_details: {
    bank_name: '',
    account_holder_name: '',
    branch_code: '',
    account_number: '',
    bank_cheque_book_scan_photo: null,
  },
};
